<template>
  <dropdown class="marketing-email-list-item-actions"
            :data-border="false"
            dataMenuWidth="115px"
            data-icon="mdi-dots-vertical"
            @hidden="hideEveryModal">

    <p class="marketing-email-list-item-actions-item pointer"
       @click.stop="showClientsModal">
      Vouchers
    </p>

    <p class="marketing-email-list-item-actions-item pointer"
       @click.stop="showEditModal">
      {{$t('message.generics.message.edit')}}
    </p>

    <p class="marketing-email-list-item-actions-item pointer"
       @click.stop="showDeleteModal">
      {{$t('message.generics.message.delete')}}
    </p>

    <confirmation-modal :value="showingSegmentDeleteModal"
                        :confirm-label="$t('message.generics.message.confirm')"
                        @confirm="deleteSegment"
                        @cancel="closeDeleteModal">
      <span slot="heading">
        Deletar Segmentação?
      </span>
      <span>
        Quer mesmo deletar esta segmentação? Esta ação é irreversível
      </span>
    </confirmation-modal>

    <voucher-segment-create-modal :manual-show.sync="showingEditModal"
                                  :item="item"
                                  no-activator />

    <voucher-segment-client-modal v-model="showingClientModal"
                                  :segment="item" />
  </dropdown>
</template>

<script>
import VoucherSegmentClientModal from "@components/modules/voucher/segment/client/modal/VoucherSegmentClientModal.vue";
import VoucherSegmentCreateModal from "@components/modules/voucher/segment/create/modal/VoucherSegmentCreateModal.vue";
import ConfirmationModal from "@components/ConfirmationModal";
import Dropdown from "@components/Dropdown";
import EventBus from "@packages/event-bus";

export default {
  components: {
    Dropdown,
    ConfirmationModal,
    VoucherSegmentCreateModal,
    VoucherSegmentClientModal,
  },
  data() {
    return {
      showingSegmentDeleteModal: false,
      showingEditModal: false,
      showingClientModal: false,
    };
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  computed: {},
  methods: {
    showClientsModal() {
      this.showingClientModal = true;
    },
    showEditModal() {
      this.showingEditModal = true;
    },
    hideEveryModal() {
      this.closeDeleteModal();
    },
    showDeleteModal() {
      this.showingSegmentDeleteModal = true;
    },
    closeDeleteModal() {
      this.showingSegmentDeleteModal = false;
    },
    async deleteSegment() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        await this.$api.core.voucher.segment.delete({
          segmentId: this.item.id,
        });

        EventBus.$emit("show-message", {
          type: "SUCCESS",
          message: "Segmento deletado com sucesso",
        });

        this.closeDeleteModal();

        this.$emit("deleted");
      } catch (error) {
        // empty
      } finally {
        EventBus.$emit("CANCEL_SPINNER");
      }
    },

    goToEditPage() {},

    async duplicateEmail({ isAutomationFlow }) {
      await this.$api.marketing.email.message.duplicate({
        isAutomation: isAutomationFlow,
        emailId: this.item.id,
      });

      this.$emit("duplicated");
    },

    emitEdited() {
      this.$emit("edited");
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-list-item-actions {
  .marketing-email-list-item-actions-item {
    margin-bottom: 0px;
    font-size: 12px;
    color: #707070;
    font-weight: 600;
    margin-bottom: 5px;

    &:hover {
      transform: translateY(-1px);
    }

    &:active {
      box-shadow: none;
      transform: translateY(1px);
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
